import { ChatConversation } from './AiChatContext';

const STORAGE_KEY = 'ai-chat-conversations';
const TTL_MS = 10 * 24 * 60 * 60 * 1000; // 10 days

export function loadConversations(): Record<string, ChatConversation> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};

    const parsed: Record<string, ChatConversation> = JSON.parse(raw);
    const now = Date.now();
    const result: Record<string, ChatConversation> = {};

    for (const [id, conversation] of Object.entries(parsed)) {
      if (now - conversation.lastActivityAt < TTL_MS) {
        result[id] = conversation;
      }
    }

    return result;
  } catch {
    return {};
  }
}

export function saveConversations(conversations: Record<string, ChatConversation>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
  } catch {
    // localStorage full or unavailable -- silently ignore
  }
}
